import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 11l5 -5l5 5","key":"svg-0"}],["path",{"d":"M7 17l5 -5l5 5","key":"svg-1"}]]

/**
 * IconChevronsUp
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hldnJvbnMtdXAiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTcgMTFsNSAtNWw1IDUiIC8+CiAgPHBhdGggZD0iTTcgMTdsNSAtNWw1IDUiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/chevrons-up
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChevronsUp = createReactComponent('outline', 'chevrons-up', 'ChevronsUp', __iconNode);

export default IconChevronsUp;